import { useEffect, useState } from 'react';
import { Skeleton } from '@/components/ui/skeleton';
import { StarRating } from '@/components/marketplace/StarRating';
import { studioGetReviews } from '@/lib/api';
import { ADMIN_MY_PROFILE as T } from '@/constants/testIds';

/** Photographer's own reviews — read-only (moderation stays with the LXRA owner). */
export const AdminReviewsCard = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    studioGetReviews().then(setData).catch(() => setData({ average: null, count: 0, reviews: [] }));
  }, []);

  if (!data) return <Skeleton className="h-40 rounded-2xl bg-[#141416]" />;

  return (
    <section data-testid={T.reviewsCard} className="rounded-2xl border border-[hsl(var(--lxra-border))] bg-[#0F0F10] p-6 space-y-4">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h3 className="font-display text-xl tracking-[0.06em] text-[hsl(var(--lxra-fg))]">CLIENT REVIEWS</h3>
          <p className="text-xs text-[hsl(var(--lxra-muted))] mt-1">Shown on your public profile once a client rates a delivered session.</p>
        </div>
        {data.count > 0 && (
          <div className="flex items-center gap-2 text-sm text-[hsl(var(--lxra-fg))]">
            <StarRating value={data.average || 0} />
            <span data-testid={T.reviewsAverage} className="lxra-mono">{data.average}</span>
            <span className="text-[hsl(var(--lxra-muted))]">({data.count})</span>
          </div>
        )}
      </div>
      {data.count === 0 ? (
        <p className="text-sm text-[hsl(var(--lxra-muted))]">No reviews yet.</p>
      ) : (
        <ul data-testid={T.reviewsList} className="space-y-4">
          {data.reviews.slice(0, 10).map((r) => (
            <li key={r.id} className="border-t border-[hsl(var(--lxra-border))] pt-4 first:border-0 first:pt-0">
              <div className="flex items-center justify-between gap-3">
                <StarRating value={r.rating} size="h-3.5 w-3.5" />
                <span className="text-[11px] text-[hsl(var(--lxra-muted))]">{new Date(r.created_at).toLocaleDateString()}</span>
              </div>
              {r.comment && <p className="mt-2 text-sm text-[hsl(var(--lxra-fg))] leading-relaxed">{r.comment}</p>}
              <p className="mt-1 text-[11px] text-[hsl(var(--lxra-muted))]">{r.client_name || 'A client'}{r.hidden ? ' · hidden from your public profile' : ''}</p>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
};
